











import Vue from 'vue';
import { EInputType } from '../../../../common/enums/frontpage.enum';

export default Vue.extend({
  name: `FrontpageInput`,
  props: {
    identifier: {
      default: ``,
      type: String,
    },
    placeholder: {
      default: ``,
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    type: {
      default: EInputType.TEXT,
      validator: val => Object.values(EInputType).includes(val),
    },
    value: {
      required: true,
      type: [String, Number],
    },
  },
});
